// @ts-nocheck
/* eslint-disable class-methods-use-this */
/* eslint-disable no-console */
import moment from 'moment';
import angular, {
	element,
	IQService,
	ISCEService,
} from 'angular';
import ColorHash from 'color-hash';
import prettyBytes from 'pretty-bytes';
import marked from 'marked';
// eslint-disable-next-line import/no-unresolved
import prism from 'prismjs';
import autosize from 'autosize';
import { createPopup } from '@picmo/popup-picker';
import { NativeRenderer } from 'picmo';
import { debounce } from 'lodash-es';
import avatarGen from '~/scripts/avatar/avatar';

// eslint-disable-next-line no-unused-vars
import Message from '~/pages/chat/models/message';
import ChatService from '~/pages/chat/chat.service';

import Defaults from '~/scripts/constants/defaults';
import Droit from '~/scripts/services/model/droit';
import FileUpload from '~/scripts/services/model/file-upload';
import { COMPOSED_OF } from '~/scripts/constants/common-kids';
import APIV5 from '~/models/api';
import EVENTS from './models/events';
import Room from './models/room';
import ChatConstants from './chat.constant';

/* globals Knitiv */

const render = new marked.Renderer();
render.link = (href, title, text) => {
	let out = `<a target="_blank" rel="noopener" href="${href}"`;
	if (title) {
		out += ` title="${title}"`;
	}
	out += `>${text}</a>`;
	return out;
};

render.code = function (code, lang) {
	const hCode = this.options.highlight(code, lang);
	if (!lang) {
		return `<pre><code>${hCode}</code></pre>`;
	}

	const langClass = `language-${lang}`;

	return `<pre class="${langClass}"><code class="${langClass}">${hCode}</code></pre>`;
};

marked.setOptions({
	renderer: render,
	highlight(code, lang) {
		try {
			return prism.highlight(code, prism.languages[lang], lang);
		}
		catch {
			return code;
		}
	},
	gfm: true,
	breaks: true,
	smartLists: true,
	smartypants: true,
});

const colorHash = new ColorHash({
	lightness: 0.45,
	saturation: 0.65,
});

/**
 * @class
 * @name ChatCtrl
 * @description
 * # ChatCtrl
 * Controller of the app
 */
export default class {
	/* @ngInject */
	constructor(
		$injector,
		$rootScope,
		$scope,
		$location,
		$route,
		$routeParams,
		$timeout,
		$translate,
		Notification,
		User,
		$q,
		$copyToClipboard,
		$uibModal,
		NodeService,
		chatService,
		$window,
		$interval,
		$sce,
	) {
		// @ts-ignore
		if (window?.DESKTOP?.isDesktop()) {
			console.log('Je suis dans Electron');
			$rootScope.showHeader = false;
		}
		else {
			console.log('Je ne suis pas dans Electron');
		}

		/** @type {Knitiv.RootScope} */
		this.$rootScope = $rootScope;

		/** @type {angular.ILocationService} $location */
		this.$location = $location;
		/** @type {angular.route.IRouteService} $route */
		this.$route = $route;
		/** @type {angular.route.IRouteParamsService} $routeParams */
		this.$routeParams = $routeParams;
		/** @type {angular.ITimeoutService} $timeout */
		this.$timeout = $timeout;
		/** @type {angular.translate.ITranslateService} $translate */
		this.$translate = $translate;
		/** @type {any} Notification */
		this.Notification = Notification;
		/** @type {User} User */
		this.User = User;
		/** @type {IQService} $q */
		this.$q = $q;
		/** @type {*} $copyToClipboard */
		this.$copyToClipboard = $copyToClipboard;
		/** @type {angular.ui.bootstrap.IModalService} $uibModal */
		this.$uibModal = $uibModal;
		/** @type {*} NodeService */
		this.NodeService = NodeService;
		/** @type $window */
		this.$window = $window;
		/** @type $interval */
		this.$interval = $interval;
		/** @type {ISCEService} $sce */
		this.$sce = $sce;
		/** @type {angular.auto.IInjectorService} $injector */
		this.$injector = $injector;
		/** @type {Chat.Controller.Scope} */
		this.$scope = $scope;

		/** @type {ChatService} chatService */
		this.chatService = chatService;

		this.statusColor = ChatConstants.statusColor;
		/** @type {import('@knitiv/api-client-javascript').AuthenticationObject} */
		this.currentUser = this.$rootScope.context;
		this.chatSearch = {
			search: [],
		};
		this.isDisabled = false;
		this.textToSend = '';
		this.isEditing = undefined;
		this.isReplying = undefined;
		this.mobileMenuOpened = false;
		this.messageViewIsLoading = false;
		// this.files = {};
		this.filesReady = [];
		this.uploadValue = 0;
		this.uploadMax = 100;
		this.isUploading = false;
		this.isDownloading = false;
		this.messages = [];
		this.debugMode = false;
		this.activeTab = 0;

		// Search

		this.search = {
			text: '',
			matches: [],
			selected: '',
		};

		const $textarea = document.querySelector('.text-to-send-textarea');
		this.$messageList = element(document.querySelector('#messages-view'));

		/** @type {HTMLTextAreaElement} */
		// @ts-ignore
		this.$textarea = autosize($textarea);

		moment().locale('fr');

		angular.element(document).ready(() => {
			/** @type {HTMLElement} */
			// @ts-ignore
			this.$trigger = document.querySelector('#emoji-trigger');

			const picker = createPopup({
				// position: 'top-end',
				renderer: new NativeRenderer(),
			}, {
				referenceElement: this.$trigger,
				triggerElement: this.$trigger,
			});
			picker.addEventListener('emoji:select', selection => {
				this.textToSend += selection.emoji;
				$timeout(() => {
					this.$textarea.focus();
				}, 10);
			});

			this.$trigger.addEventListener('click', () => picker.open());
		});

		$scope.$watch(() => chatService.recipient, () => {
			this.$timeout(() => {
				console.log('change focus');
				if (this.$messageList && this.chatService.getCurrentRoom()) {
					this.$messageList.scrollTop(this.chatService.getCurrentRoom().scrollTop);
				}
				this.$textarea.focus();
			}, 10);
		});

		$scope.$watch('textToSend', () => {
			this.$timeout(() => {
				autosize.update(this.$textarea);
			});
		});

		/** @type {?Function} Désinscription de l'abonnement posé sur $rootScope */
		let offMessageCreate = null;

		$scope.$on('$destroy', () => {
			offMessageCreate?.();
			offMessageCreate = null;
		});

		$scope.$on(EVENTS.CHAT.READY, () => {
			// Ensure everything is setup in the view after loading the chat
			$timeout(() => {
				/**
				 * @type {Message}
				 * @param {Message} message
				 */
				// CHAT.READY peut survenir plusieurs fois : sans cette désinscription,
				// chaque occurrence ajoutait un abonnement global de plus, qui traitait
				// le même message autant de fois et retenait le contrôleur.
				offMessageCreate?.();
				offMessageCreate = $rootScope.$on(EVENTS.CHAT.MESSAGE.CREATE,
					// @ts-ignore
					(event, message) => {
						this.$scope.$applyAsync(() => {
							if (
								chatService.recipient === message.room_kid
								&& chatService.getCurrentRoom().autoScrollDown
							) {
								this.scrollToBottom();
							}
						});
					});
			});
		});

		$scope.$on(EVENTS.CHAT.INITIAL_ROOM_FETCH, () => {
			$timeout(() => {
				this.scrollToBottom();
				this.$messageList.on('scroll', () => debounce(this.watchScroll, 500));
			}, 100);
		});

		/* ================================== */

		// Events
		this.menuOptions = [
			{
				text: '<i class="glyphicon glyphicon-duplicate"></i> <span class="context-menu-text">Copier le message</span>',
				click: (_1, _2, modelValue) => {
					this.$copyToClipboard(modelValue.text, true, () => 'Message copié dans le presse-papiers !');
				},
			},
			{
				text: '<i class="glyphicon glyphicon-edit"></i> <span class="context-menu-text">Éditer le message</span>',
				click: (_1, _2, modelValue) => {
					this.isEditing = modelValue;
					this.textToSend = modelValue.text;
					this.$timeout(() => {
						this.$textarea.focus();
					});
				},
				displayed: (_1, _2, modelValue) => (
					this.isSelf(modelValue)
					&& !this.isEditing
					&& modelValue.status !== 'errored'
				),
			},
			{
				text: '<i class="glyphicon glyphicon-share"></i> <span class="context-menu-text">Répondre</span>',
				click: (_1, _2, modelValue) => {
					this.isReplying = modelValue;
					this.$timeout(() => {
						this.$textarea.focus();
					});
				},
			},
			{
				text: '<i class="glyphicon glyphicon-edit"></i> <span class="context-menu-text">Annuler l\'édition</span>',
				click: () => {
					this.isEditing = undefined;
					this.textToSend = '';
				},
				displayed: (_1, _2, modelValue) => (
					this.isSelf(modelValue)
					&& this.isEditing
					&& this.isEditing.ref === modelValue.ref
				),
			},
			{
				text: '<i class="glyphicon glyphicon-trash"></i> <span class="context-menu-text">Supprimer le message</span>',
				click: (_1, _2, modelValue) => {
					this.chatService.deleteMessage(modelValue);
				},
				displayed: (_1, _2, modelValue) => modelValue.status !== 'errored' && this.isSelf(modelValue),
			},
			{
				text: `<i class="glyphicon glyphicon-share-alt"></i>
<span class="context-menu-text">Renvoyer le message</span>`,
				click: (/* _1, _2, modelValue */) => {
				// TODO
				// $scope.send();
				// chatService.removeMessage(modelValue.ref);
					throw new Error('not implemented');
				},
				displayed: (_1, _2, modelValue) => this.isSelf(modelValue) && modelValue.status === 'errored',
			},
			{
				text: '<i class="glyphicon glyphicon-remove"></i> <span class="context-menu-text">Annuler l\'envoi</span>',
				click: (_1, _2, modelValue) => {
					this.chatService.removeMessage(modelValue.ref);
				},
				displayed: (_1, _2, modelValue) => this.isSelf(modelValue) && modelValue.status === 'errored',
			},
			{
				text: '<i class="glyphicon glyphicon-info-sign"></i> <span class="context-menu-text">Infos du message</span>',
				click: (_1, _2, modelValue) => {
					this.$window.alert(`
Status: ${modelValue.status}
Envoyé le: ${moment.utc(modelValue.create_date).local().format(ChatConstants.humanDateFormat)}
Mis à jour le: ${moment.utc(modelValue.update_date).local().format(ChatConstants.humanDateFormat)}
Profil d'envoi: ${this.chatService.representations.get(modelValue.from_profil_kid)} (${modelValue.from_profil_kid})
${modelValue.status === 'errored' ? 'Erreur: '.concat(modelValue.error) : ''}`);
				},
			},
		];

		this.contextMenuContact = [
			{
				text: '<i class="fa fa-edit"></i> <span class="context-menu-text">Éditer le groupe</span>',
				displayed: (_item, _event, modelValue) => !this.chatService.rooms.get(modelValue).isOneToOne(),
				// @ts-ignore
				click: ($itemScope, $event, roomKid) => {
					const groupKid = this.chatService.rooms.get(roomKid).id;
					return this.NodeService
						.load(groupKid)
						.then(node => {
							if (node.checkDroit(Defaults.DROIT.MODIFY)) {
								this.openAdminModal(node);
							}
							else {
								this.Notification.error({
									title: 'Erreur',
									message: 'Vous n\'avez pas la permission de modifier ce salon',
								});
							}
							return node;
						});
				},
			},
			{
				text: '<i class="fa fa-remove"></i> <span class="context-menu-text">Cacher la conversation</span>',
				// @ts-ignore
				click: ($itemScope, $event, roomKid) => {
					this.chatService.removeRoomFromRecent(roomKid);
				},
			},
		];
		if (process.env.NODE_ENV !== 'production') {
			this.contextMenuContact.push({
				text: '<i class="fa fa-copy"></i> <span class="context-menu-text">Copier le kid</span>',
				// @ts-ignore
				click: ($itemScope, $event, roomKid) => {
					this.$copyToClipboard(roomKid, true, v => `${v} copié dans le presse-papiers !`);
				},
			});
		}
	}

	colorHash(string) {
		return colorHash.hex(string);
	}

	searchMessage() {
		console.log('this.search', this.search);
		this.chatService.search(this.search)
			.then(data => {
				console.log('data', data);
				return this.$timeout(() => {
					this.search.matches = data;
				});
			})
			.catch(error => {
				console.error(error);
			});
	}

	scrollToContext(messageReference) {
		console.time('Start');
		const message = this.chatService.messageManager.get(messageReference);
		this.search.selected = message.id;
		return this.changeRoom(message.room_kid, true)
			.then(() => this.chatService.queryMessageContext(message))
			.then(() => {
				console.timeEnd('Start');
				const escapedId = `#${CSS.escape(message.id)}`;
				console.log('escapedId', escapedId);

				const $message = angular.element(escapedId);

				$message.addClass('expose');
				this.$timeout(() => {
					$message.removeClass('expose');
				}, 2000);
				document.querySelector(escapedId).scrollIntoView({
					block: 'center',
					behavior: 'smooth',
					inline: 'nearest',
				});
				// angular.element('#messages-view').animate({
				// 	scrollTop: $message.offset().top + $message.height() / 2,
				// }, 500);
				return true;
			});
	}

	debugValues() {
		this.chatService.debugValues();
	}

	onChatSearch($item) {
		const item = angular.copy($item);
		const items = item ? this.$q.resolve(this.chatService.onChatSearch(item)) : this.$q.resolve({});
		items.then(data => this.$timeout(() => {
			this.chatSearch.search.splice(0, 1);
			return data;
		})).catch(error => {
			console.warn('error', error);
		});
	}

	openAdminModal(node) {
		const modalInstance = this.$uibModal.open({
			templateUrl: '/templates/modal/chat-administration.html',
			controller: 'ModalChatAdminCtrl',
			resolve: {
				node: () => node,
				create: false,
			},
		});

		return modalInstance.result.then(object => this.NodeService.update(object))
			.then(() => this.Notification.info({
				title: 'Enregistrement',
				message: 'Enregistrement effectué avec succès',
			}));
	}

	handlePaste(data) {
		console.log('handlePaste');
		console.log('data', data);
		const { originalEvent } = data;
		const { clipboardData } = originalEvent;

		const item = clipboardData.items[0];

		if (item.type.startsWith('image')) {
			const blob = item.getAsFile();
			this.addFiles([blob]);/* TODO make a promise
				.then((files) => {
					console.log('files', files);
				}); */
		}
	}

	getSize(size) {
		if (!size) {
			return 0;
		}
		return prettyBytes(size, { locale: 'fr' });
	}

	addFiles(files) {
		console.log('files', files);
		if (this.isUploading) {
			throw new Error('Operation in progress');
		}
		if (!this.chatService.recipient) {
			this.Notification.error({
				title: 'Erreur',
				message: 'Sélectionnez un salon avant de partager des fichiers',
			});
			return;
		}

		this.$timeout(() => {
			for (const file of files) {
				const fileUpload = new FileUpload(this.$injector, file);
				this.filesReady.push(fileUpload);
			}
		});
	}

	removeReadyFile(index) {
		this.filesReady.splice(index, 1);
	}

	openAdminGroupCreateModal() {
		const node = this.NodeService.create('K_NODE;KCHAT_GROUP');
		const droit = new Droit({
			kright: Defaults.DROIT.ALL,
			role: {
				kid: this.currentUser.person.kid,
				isa: 'K_NODE;KPROFIL',
			},
		});
		node.addDroit(droit);
		const modalInstance = this.$uibModal.open({
			templateUrl: '/templates/modal/chat-administration.html',
			controller: 'ModalChatAdminCtrl',
			resolve: {
				node: () => node,
				create: true,
			},
		});

		return modalInstance.result
			.then(object => this.NodeService.update(object))
			.then(() => this.Notification.info({
				title: 'Droits',
				message: 'Droits mis à jour',
			}));
	}

	cancelReply() {
		this.isReplying = undefined;
	}

	parseContent(text = '') {
		const markdownified = marked(text);
		return this.$sce.trustAsHtml(markdownified);
	}

	/**
	 *
	 * @param {Message} messageReference
	 */
	markAsSeen(messageReference) {
		this.chatService.markAsSeen(messageReference);
	}

	changeRoom(...arguments_) {
		this.cancelEdit();
		this.cancelReply();
		return this.chatService.changeRoom(...arguments_);
	}

	/**
	 * Scroll
	 */

	scrollToBottom() {
		this.$timeout(() => {
			this.$messageList.scrollTop(this.$messageList.prop('scrollHeight'));
			this.chatService.getCurrentRoom().autoScrollDown = true;
		});
	}

	hasScrollReachedBottom() {
		return this.$messageList.scrollTop() + this.$messageList.innerHeight() >= this.$messageList.prop('scrollHeight');
	}

	hasScrollReachedTop() {
		return this.$messageList.scrollTop() === 0;
	}

	/**
	 * / Scroll
	 */

	fromNow(time) {
		return moment.utc(time).calendar();
	}

	getHour(time) {
		return moment.utc(time).local().format('HH:mm');
	}

	getDate(time) {
		return moment.utc(time).local().format('DD MMMM YYYY, HH:mm');
	}

	getDay(time) {
		const utcTime = moment.utc(time);
		// const isSameYear = moment.utc(time).year() === moment.utc().year();
		const isSameYear = utcTime.year() === moment.utc().year();
		return utcTime.format(`D MMMM ${isSameYear ? '' : 'YYYY'}`);
	}

	isSelf(message) {
		return message.from_profil_kid === this.currentUser.profil.kid;
	}

	chatDate(a, b) {
		return moment.utc(a.create_date).diff(moment.utc(b.create_date));
	}

	hasAttachment(message) {
		return message.fileid !== '0' && message.fileid !== 0;
	}

	isMessageEdited(message) {
		return !moment.utc(message.create_date)
			.isSame(moment.utc(message.update_date));
	}

	isMessageReaded(message) {
		return message.status === 'seen';
	}

	isMessageSent(message) {
		return message.status === 'sent';
	}

	isMessageErrored(message) {
		return message.status === 'errored';
	}

	getAuthorAvatar(profilKid) {
		return avatarGen(
			this.chatService.representations.get(profilKid) ?? profilKid,
			50,
			'#fff',
			colorHash.hex(profilKid),
		);
	}

	isNotSameAuthor(author1, author2) {
		return author1 !== author2;
	}

	handleShortcuts(event) {
		// send
		if (
			// enter
			event.key === 'Enter'
				// not empty
				&& (this.textToSend !== '' || (this.textToSend === '' && this.filesReady.length > 0))
		) {
			// SHIFT, because ctrl is reserved for the browser
			// eslint-disable-next-line no-empty
			if (event.shiftKey) {}
			else {
				event.preventDefault();

				this.send();
			}
		}

		// edit last
		if (
			event.key === 'ArrowUp'
				&& this.textToSend === ''
		) {
			/** @type {Array<Message>} */
			const messages = this.chatService
				.getMessagesFromRoom(this.chatService.recipient)
				.filter(message => this.isSelf(message))
				.reverse();
			if (messages && messages.length > 0 && messages[0]) {
				this.isEditing = messages[0];
				this.textToSend = messages[0].text;
			}
		}

		if (event.key === 'Escape' && (this.isEditing || this.isReplying)) {
			this.cancelEdit();
		}
	}

	cancelEdit() {
		this.isEditing = undefined;
		this.textToSend = '';
		console.log('this.$textarea', this.$textarea);
		this.$timeout(() => {
			autosize.update(this.$textarea);
		});
	}

	onViewerError(error, kid) {
		console.log('error', error);
		console.log('kid', kid);
	}

	/**
	 *
	 * @param {Chat.Message} message
	 */
	async addToMemory(message) {
		if (message.fileid === '0') {
			return 0;
		}
		return APIV5
			.instance
			.fileInfo({
				nodeid: message.fileid,
			})
			.then(upload => ({
				'K_NODE;_NR_DOCUMENT': {
					action: 'ADD',
					isa: 'K_NODE;DOCUMENT',
					REPRE_LIST: [
						{
							action: 'ADD',
							name: upload.filename,
							lang: 'K_NODE;UNIVERSEL',
						},
					],
					LINK_LIST: {
						[COMPOSED_OF]: [
							{
								action: 'ADD',
								objnum2: 'K_NODE;_NR_DATE1',
								objnum2_isa: 'K_NODE;DATE',
							},
						],
					},
				},
				'K_NODE;_NR_DATE1': {
					action: 'ADD',
					isa: 'K_NODE;DATE',
					REPRE_LIST: [
						{
							action: 'ADD',
							name: moment.utc().format('YYYY-MM-DD'), // '2015-10-26',
							lang: 'K_NODE;UNIVERSEL',
						},
					],
				},
			}))
			.then(objectList => APIV5.instance.nodeFromFile({
				fileid: message.fileid,
				target_objnum: 'K_NODE;_NR_DOCUMENT',
				OBJECT_LIST: objectList,
			}, { id: 'chat.add-to-memory' }))
			.then(node => {
				console.log('node', node);
				const NRDocument = node._NR_replace['K_NODE;_NR_DOCUMENT'];
				return node.result[NRDocument].objid;
			})
			.then(async documentkid => {
				const result = await this.chatService.messageUpdate(message.ref, {
					fileid: documentkid,
					update_date: moment.utc().format(ChatConstants.dateFormat),
				});
				return this.$q.when(result[result.elt_kid].data);
			})
			.then(async message_ => {
				console.log('message update', message_);
				/**
				 * @type {Room}
				 */
				const room = this.chatService.rooms.get(message_.room_kid);
				return room.listener.sendAll({
					type: EVENTS.CHAT.MESSAGE.UPDATE,
					message: message_,
				});
			});
	}

	/**
	 * @param {Message} message
	 */
	downloadAttachment(message) {
		console.log('this.isUploading', this.isUploading);
		console.log('this.isDownloading', this.isDownloading);

		console.log('message', message);

		message.downloadAttachment();
	}

	getRoomStatus(roomReference) {
		const parts = this.chatService.rooms.get(roomReference).getRoomParts();
		for (const part of parts) {
			if (part !== this.chatService.currentUser.person.kid) {
				return this.chatService.statuses.get(part) ?? 'offline';
			}
		}
		return 'offline';
	}

	// TODO too long
	isNotSameDay(date1, date2) {
		return moment.utc(date1).dayOfYear() !== moment.utc(date2)
			.dayOfYear();
	}

	lessThan5minutes(message1, message2) {
		if (!message1 || !message2) {
			return false;
		}
		return (
			moment.utc(message1.create_date).diff(moment().diff(message2.create_date), 'minutes') < 5
				&& message1.from_profil_kid === message2.from_profil_kid
		);
	}

	/**
	 *
	 * @param {string} recipient
	 * @returns {*}
	 */
	messagesFromRoom(recipient) {
		return this.chatService
			.getMessagesFromRoom(recipient);
	}

	getMessageByRef(reference) {
		const message = this.chatService.messageManager.get(reference);
		if (!message) {
			return {};
		}
		return message;
	}

	addCarriageReturn() {
		const textarea = this.$textarea;

		if (textarea.selectionStart !== undefined) {
			const end = textarea.selectionEnd;
			const before = this.textToSend.slice(0, end);
			const after = this.textToSend.slice(end);
			this.textToSend = `${before}\r\n${after}`;
			this.$timeout(() => {
				autosize.update(this.$textarea);
				this.$textarea.focus();
				this.$textarea.selectionStart = end + 1;
				this.$textarea.selectionEnd = end + 1;
			});
		}
	}

	/**
	 * @param {Message['ref']} reference
	 * @param {Chat.AttachmentState['collapsed']} status
	 */
	async setMessageState(reference, status) {
		/** @type {Message} */
		const message = this.chatService.messageManager.get(reference);

		const set = await this.chatService.setFileState(message.attachment.state.ref, {
			file_kid: message.attachment.infos.nodeid,
			person_kid: message.from_profil_kid,
			room_kid: message.room_kid,
		}, {
			collapsed: status,
		});

		const dataRAW = set[set.elt_kid].data;
		const dataJSON = dataRAW.data;
		const data = JSON.parse(dataJSON);

		message.attachment.state.data = data;
		message.attachment.state.ref = dataRAW.ref;
	}

	// eslint-disable-next-line consistent-return
	async send() {
		const messages = [];
		console.log('$scope.filesReady', this.filesReady);
		if (this.filesReady.length > 0) {
			if (this.isDownloading || this.isUploading) {
				console.log('this.isDownloading', this.isDownloading);
				console.log('this.isUploading', this.isUploading);
				this.Notification.error({
					title: 'Erreur',
					message: 'Une action est déjà en cours, veuillez réessayer plus tard',
				});
				throw new Error('Unable to upload');
			}

			console.log('this.filesReady', this.filesReady);
			this.isUploading = true;

			const messagesP = [];

			for (const file of this.filesReady) {
				messagesP.push(async () => {
					console.log('file', file);
					await file.upload('kchat');

					file.isa = 'K_NODE;DOCUMENT';
					file.uploaded = true;

					// @ts-ignore
					const message = await this.chatService.send({
						text: '',
						file,
						isEditing: null,
						isReplying: null,
						room: this.chatService.recipient,
					});

					messages.push(message);
				});
			}

			await Promise.all(messagesP.map(p => p()));

			/* for (const file of this.filesReady) {
				console.log('file', file);
				await file.upload('kchat');

				file.isa = 'K_NODE;DOCUMENT';
				file.uploaded = true;

				const message = await this.chatService.send({
					text: '',
					file,
					isEditing: null,
					isReplying: null,
					room: this.chatService.recipient,
				});

				messages.push(message);
			} */

			this.isUploading = false;
		}

		console.log('$scope.textToSend', this.textToSend);
		if (this.textToSend) {
			this.isDisabled = true;

			console.log('this.isEditing', this.isEditing);

			// @ts-ignore
			const message = await this.chatService.send({
				text: this.textToSend,
				file: null,
				isEditing: this.isEditing,
				isReplying: this.isReplying,
				room: this.chatService.recipient,
			});

			messages.push(message);
		}
		this.$timeout(() => {
			this.isDisabled = false;
			this.textToSend = '';
			this.filesReady.splice(0, this.filesReady.length);
			this.filesReady.length = 0;
			this.filesReady = [];
			console.log('this.filesReady', this.filesReady);
			this.isEditing = undefined;
			this.isReplying = undefined;
			this.isUploading = false;
		});

		this.$timeout(() => {
			this.$textarea.focus();
		}, 10);

		return messages;
	}

	getRecentConversations() {
		return this.chatService.getRecentsRoom().toObject();
	}

	// Events

	onFileLoaded(file) {
		this.chatService.attachments.set(file.id, file);
		// $scope.scrollToBottomOfMessageView(true, false);
	}

	loadOlderMessages() {
		const content = document.querySelector('.messages-view');
		const currentScrollPos = content.scrollTop;
		const oldScroll = content.scrollHeight - content.clientHeight;

		this.$q.resolve(
			this.chatService.fetchNewMessages(this.chatService.recipient, 0),
		)
		// TODO prevent jump
			.then(() => this.$timeout(() => {
				const newScroll = content.scrollHeight - content.clientHeight;
				content.scrollTop = currentScrollPos + (newScroll - oldScroll);
			}))
			.catch(error => {
				console.error(error);
			});
	}

	watchScroll() {
		if (this.hasScrollReachedTop()) {
			if (this.chatService.getCurrentRoom().noMoreMessagesUp) {
				// ngNotify.set('All the messages have been loaded', 'grimace');
				console.log('All messages fetched');
			}
			else {
				// fetchPreviousMessages();
			}
		}

		// Update the autoScrollDown value
		this.chatService.getCurrentRoom().autoScrollDown = this.hasScrollReachedBottom();
		this.chatService.getCurrentRoom().scrollTop = this.$messageList.scrollTop();
	}
}
